import { makeSelectIsBootstrapTypesLoaded } from 'selectors/bootstrap/makeSelectIsBootstrapTypesLoaded'

export const selectIsChatBootstrapped = makeSelectIsBootstrapTypesLoaded([
  'account',
  'widgets',
])
